import * as marietta from '../../..';
import { Dialog } from '../../../core/view';

/**
 * 屋根種別選択ダイアログ
 * 屋根入力完了後に表示される
 */
class RoofTypeSelection extends Dialog {
    info: marietta.webcad.collection.ItemInfoCollection;

    /**
     * コンストラクタ
     */
    constructor(draggable: boolean) {
      super(draggable);
      // ダイアログのコンテンツ生成
      const id = 'roofStyleDialog';
      let title = '';
      // タイトル
      switch (marietta.webcad.WebCADGlobal.language) {
        case 'jp': title = '屋根スタイルを選択してください'; break;
        default: title = 'Select a Roof Style'; break;
      }

      let contents = '<div class="dialogRoofStyleBox">\n';

      // 寄せ・切り
      contents += '<div class="roofStyleBtn">\n';
      contents += '<a href="javascript:void(0)">\n';
      contents += '<div class="roofStyleImage">\n';
      contents += `<img src="${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}roofType1.png" alt="">\n`;
      contents += '</div>\n';
      contents += '<div class="roofStyleTitle">\n';
      contents += (marietta.webcad.WebCADGlobal.language === 'jp') ? '寄棟・切妻' : 'Hip or Gable';
      contents += '</div>\n';
      contents += '</a>\n';
      contents += '</div>\n';
      // 片流れ
      contents += '<div class="roofStyleBtn">\n';
      contents += '<a href="javascript:void(0)">\n';
      contents += '<div class="roofStyleImage">\n';
      contents += `<img src="${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}roofType2.png" alt="">\n`;
      contents += '</div>\n';
      contents += '<div class="roofStyleTitle">\n';
      contents += (marietta.webcad.WebCADGlobal.language === 'jp') ? '片流れ' : 'Shed roof';
      contents += '</div>\n';
      contents += '</a>\n';
      contents += '</div>\n';
      // フラット
      contents += '<div class="roofStyleBtn">\n';
      contents += '<a href="javascript:void(0)">\n';
      contents += '<div class="roofStyleImage">\n';
      contents += `<img src="${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}roofType3.png" alt="">\n`;
      contents += '</div>\n';
      contents += '<div class="roofStyleTitle">\n';
      contents += (marietta.webcad.WebCADGlobal.language === 'jp') ? 'フラット' : 'Flat roof';
      contents += '</div>\n';
      contents += '</a>\n';
      contents += '</div>\n';
      // 注意書き
      contents += '<div class="roofStyleComment"><span class="jp">※切妻の場合は、「寄棟・切妻」を選択した後、妻辺を設定してください。</span><span class="en">*To create a gable roof, select Hip or Gable then input the open side.</span></div>\n';
      contents += '</div>';

      const footer = '';

      this.createDialog(id, title, contents, footer);

      this.viewObj.querySelectorAll('.roofStyleBtn').forEach((element) => {
        element.addEventListener('click', this.close);
      });
      document.getElementById('roofStyleDialog').querySelectorAll('.roofStyleBtn').forEach((element) => {
        element.addEventListener('click', this.onSelectRoofStyle);
      });
    }

    /**
     * 屋根のスタイルが選択された
     */
    onSelectRoofStyle = (e: { preventDefault: () => void; currentTarget: any; }) => {
      e.preventDefault();
      const index = Array.from((<HTMLElement>e.currentTarget).parentNode.children).indexOf((<HTMLElement>e.currentTarget));
      // 屋根タイプ
      this.info.roof_type = (index + 1);

      switch (this.info.roof_type) {
        case 2:
          // ダイアログを表示
          // eslint-disable-next-line no-case-declarations
          const dialog: any = marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.RoofDirectionSelection, true, true, false) as marietta.webcad.view.dialog.RoofDirectionSelection;
          dialog.info = this.info;
          break;
        case 1:
        case 3:
          // 作成
          // eslint-disable-next-line no-case-declarations
          const createdItem:any = marietta.webcad.WebCADGlobal.itemManager.createItem(this.info);

          // 屋根形状作成
          marietta.webcad.WebCADGlobal.cadAPIManager.getRoof((list: any) => {
            createdItem.onDrawRoofDesign(list);

            // 寄棟は、次のアシスタントダイアログを表示
            if (this.info.roof_type === 1) {
              // ダイアログを表示
              marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.RoofGuidanceYosemune, true, true, false);
            }
          }, createdItem.onRoofApiFailed);
          marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();

          break;
        default:
          break;
      }
    }
}

export default RoofTypeSelection;
